import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';

interface Props {}

export function ReservationsTable({}: Props) {
  const rows = [
    {
      _id: '1234',
      size: 1024,
      assets: [
        {
          amount_free_resevations_in: 1,
          hash: 'aefqewf',
          base_model_type: 'aefaef',
          name: 'vae',
          version: '1',
          size_on_disk: 50,
          using_times_last_30_days: 45,
        },
        {
          amount_free_resevations_in: 0,
          hash: 'cwerwer',
          base_model_type: 'model_y',
          name: 'unet',
          version: '1.5',
          size_on_disk: 200,
          using_times_last_30_days: 150,
        },
      ],
    },
    {
      _id: '5678',
      size: 1024,
      assets: [
        {
          amount_free_resevations_in: 3,
          hash: 'bqweqwr',
          base_model_type: 'model_x',
          name: 'text_encoder',
          version: '2.0',
          size_on_disk: 120,
          using_times_last_30_days: 88,
        },
        {
          amount_free_resevations_in: 1,
          hash: 'aefqewf',
          base_model_type: 'aefaef',
          name: 'vae',
          version: '1',
          size_on_disk: 50,
          using_times_last_30_days: 45,
        },
      ],
    },
    {
      _id: '9012',
      size: 1024,
      assets: [
        {
          amount_free_resevations_in: 0,
          hash: 'cwerwer',
          base_model_type: 'model_y',
          name: 'unet',
          version: '1.5',
          size_on_disk: 200,
          using_times_last_30_days: 150,
        },
        {
          amount_free_resevations_in: 1,
          hash: 'aefqewf',
          base_model_type: 'aefaef',
          name: 'vae',
          version: '1',
          size_on_disk: 50,
          using_times_last_30_days: 45,
        },
      ],
    },
    {
      _id: '3456',
      size: 1024,
      assets: [
        {
          amount_free_resevations_in: 5,
          hash: 'dwqeqwe',
          base_model_type: 'model_z',
          name: 'controlnet',
          version: '3.1',
          size_on_disk: 300,
          using_times_last_30_days: 12,
        },
        {
          amount_free_resevations_in: 0,
          hash: 'cwerwer',
          base_model_type: 'model_y',
          name: 'unet',
          version: '1.5',
          size_on_disk: 200,
          using_times_last_30_days: 150,
        },
        {
          amount_free_resevations_in: 1,
          hash: 'aefqewf',
          base_model_type: 'aefaef',
          name: 'vae',
          version: '1',
          size_on_disk: 50,
          using_times_last_30_days: 45,
        },
      ],
    },
  ];

  /*
   * METHODS
   */

  /*
   * METHODS
   */

  /*
   * RENDERS
   */

  function render_rows() {
    return rows.map(row => {
      return render_row(row);
    });
  }

  function render_row(row: any) {
    return (
      <div className="w-full h-auto border-2 p-2 rounded-lg border-component-border flex items-center justify-center flex-col">
        <div className="w-full flex justify-between items-center">
          <div>{row._id}</div>
          <div className="flex gap-2 items-center">
            <div>{row.size}GB</div>
            <div>
              <UI_PRIMITIVE__button>Delete</UI_PRIMITIVE__button>
            </div>
          </div>
        </div>
        {render_assets(row.assets)}
      </div>
    );
  }

  function render_assets(assets: any) {
    return (
      <div className="w-full flex flex-col gap-1">
        {assets.map((asset: any) => {
          return render_asset(asset);
        })}
      </div>
    );
  }

  function render_asset(asset: any) {
    return (
      <div className="px-2 w-full h-[40px] flex items-center justify-start gap-2 border border-component-border rounded-lg">
        <div className="w-[100px]">{asset.name}</div>
        <div className="w-[100px]">{asset.amount_free_resevations_in}</div>
        <div className="w-[100px]">{asset.hash}</div>
        <div className="w-[100px]">{asset.base_model_type}</div>
        <div className="w-[100px]">{asset.version}</div>
        <div className="w-[100px]">{asset.size_on_disk}</div>
        <div className="w-[100px]">{asset.using_times_last_30_days}</div>
      </div>
    );
  }

  function render_header() {
    return (
      <div className="px-4 w-full h-[40px] flex items-center justify-start gap-2 bg-component-item">
        <div className="w-[100px] overflow-hidden">name</div>
        <div className="w-[100px] overflow-hidden">amount_free_resevations_in</div>
        <div className="w-[100px] overflow-hidden">hash</div>
        <div className="w-[100px] overflow-hidden">base_model_type</div>
        <div className="w-[100px] overflow-hidden">version</div>
        <div className="w-[100px] overflow-hidden">size_on_disk</div>
        <div className="w-[100px] overflow-hidden">using_times_last_30_days</div>
      </div>
    );
  }

  /*
   * HTML
   */

  return (
    <div className="flex flex-col h-full">
      {render_header()}
      <div className="relative overflow-auto h-full flex flex-col gap-1">{render_rows()}</div>
    </div>
  );
}
